export default __webpack_public_path__ + "static/media/Kaspy-BG.5ec1258e.webp";